import GetFiveAccomplishments from './GetFiveAccomplishments'
export default GetFiveAccomplishments
